import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import ExternalServiceForm from "../../components/service/externalServiceForm.component";
import { useHasPermission } from "../../contexts/auth";
import { ExternalService } from "../../types/externalServices";

export const ExternalServicesListActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [addOpened, setAddOpened] = useState(false);
  const canAdd = useHasPermission("service.add_externalservice");

  const actions: Action[] = [
    {
      id: "add-external-service",
      icon: <AddIcon />,
      label: t("Add external service"),
      onClick: () => setAddOpened(true),
      disabled: !canAdd,
    },
  ];

  const handleAdded = (externalService?: ExternalService) => {
    setAddOpened(false);
    window.dispatchEvent(new Event("externalServiceAdded"));
    if (externalService?.id) {
      navigate(`/service/external-services/${externalService.id}`);
    }
  };

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={addOpened}
        setOpened={setAddOpened}
        title={t("Add external service")}
        width="min(960px, 96vw)"
        content={<ExternalServiceForm onSuccess={handleAdded} />}
      />
    </>
  );
};
